export default __webpack_public_path__ + "static/media/CHL.e95dfadc.svg";